module.exports = __webpack_public_path__ + "img/weddingRingsSecretHeart-Collage.ac8eb5c.webp";